/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Bc_RecordsInputs */

const en_nav_bc_records = /** @type {(inputs: Nav_Bc_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central records`)
};

/**
* | output |
* | --- |
* | "Business Central records" |
*
* @param {Nav_Bc_RecordsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_bc_records = /** @type {((inputs?: Nav_Bc_RecordsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Bc_RecordsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_bc_records(inputs)
});